{
  "close": "Zavřít"
}
